import { api } from '../config/api'
import { defaultProgramsPageSize, educationalProgramLanguageStatus } from '../utils/constants'

const baseEndpoint = '/krea/EducationalProgram'

export const createEducationalContent = ({ locale, contentType }) => api.post(`${baseEndpoint}`, { ignoreLocale: true }, { params: { locale, contentType } })

export const getEducationalContent = (id) => api.get(`${baseEndpoint}/${id}`)

export const getEducationalContentCompleteness = ({ id, locale }) => api.get(`${baseEndpoint}/${id}/Completeness`, { params: { locale } })

export const getEducationalContentLanguageCompleteness = (id) => api.get(`${baseEndpoint}/${id}/CalculateCompleteness`)

export const getEducationalContentResources = ({ id, pageNumber, pageSize, locale }) =>
  api.get(`${baseEndpoint}/${id}/PagedResources`, { params: { pageNumber, pageSize, locale } })

export const editEducationalContentResourcesOrder = ({ id, resources }) =>
  api.put(`${baseEndpoint}/${id}/OrderResources`, resources)

export const setEducationalContentKeywords = ({ id, keywords }) =>
  api.put(`${baseEndpoint}/${id}/Keywords`, keywords)

export const setEducationalContentStatus = ({ id, status, locales }) =>
  api.put(`${baseEndpoint}/${id}/UpdateStatus`, { status, locales })

export const deleteEducationalContent = ({ id, locale }) => api.delete(`${baseEndpoint}/${id}`, { params: { locale } })

export const addLanguageKreaEducationalContent = ({ id, locale }) =>
  api.post(`${baseEndpoint}/${id}/LocalizedEducationalProgram`, { ignoreLocale: true }, { params: { locale } })

export const editEducationalContent = ({ id, locale, data }) => api.put(`${baseEndpoint}/${id}`, { ...data, ignoreLocale: true }, { params: { locale } })

export const editEducationalContentType = ({ id, contentType }) => api.put(`${baseEndpoint}/${id}/ContentType`, contentType)

export const associateResourceToEducationalContent = ({ id, locale, resourceId }) =>
  api.put(`${baseEndpoint}/${id}/Resources`, resourceId, { params: { locale } })

export const getPublishedEducationalContent = ({ pageNumber, pageSize = defaultProgramsPageSize, filters }) =>
  api.get(`${baseEndpoint}`, { params: { pageNumber, pageSize, ...filters, status: educationalProgramLanguageStatus.approved } })

export const getDraftsEducationalContent = ({ pageNumber, pageSize = defaultProgramsPageSize, filters }) =>
  api.get(`${baseEndpoint}`, { params: { pageNumber, pageSize, ...filters, status: educationalProgramLanguageStatus.hidden } })

export const searchAuthors = (filters) =>
  api.get(`${baseEndpoint}/AvailableAuthors`, { params: { ...filters } })

export const searchKreaContentAuthors = ({ contentId, ...filters }) =>
  api.get(`${baseEndpoint}/${contentId}/Authors`, { params: { ...filters } })

export const associateAuthorsToKreaContent = ({ authors, id, url }) =>
  api.put(`${baseEndpoint}/${id}/Authors`, authors, { params: { url } })
